import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/common/header/header";
import HeroSection from "./features/LandingPage/herosection/herosection";
import LaundryService from "./features/LandingPage/laundryservice/laundryservice";
import AboutUs from "./features/LandingPage/aboutus/aboutus";
import WhyChooseUs from "./features/LandingPage/whychooseus/whychooseus";
import Advertise from "./features/LandingPage/advertise/advertise";
import ContactUs from './features/LandingPage/contactus/contactus';
import Footer from "./components/common/footer/footer";
import AdminLogin from "./features/admin/login/LoginPage";
// import Dashboard from "./features/admin/dashboard/dashboard";
import AdminLayout from "./components/common/layout/adminlayout";
// import Orders from "./features/admin/orders/order";
// import { Services } from "./features/admin/product-manager/services";
// import { Variants } from "./features/admin/product-manager/variants";
// import { Products } from "./features/admin/product-manager/products";
// import { Coupons } from "./features/admin/product-manager/coupons";
// import { Notification } from "./features/admin/notification/notifications";
// import Price from "./features/admin/subscription/price";
// import { Purchase } from "./features/admin/subscription/purchase";
// import { ShopList } from "./features/admin/report/shop-list";
// import { Revenue } from "./features/admin/report/revenue";
// import { AppBanners } from "./features/admin/appBanner/app-banner";
// import { Customers } from "./features/admin/customers/customers";
// import { Drivers } from "./features/admin/drivers/drivers";
// import { Stores } from "./features/admin/stores/stores";
// import { ShopsList } from "./features/admin/shops/shops";
// import { AllAdmins } from "./features/admin/alladmin/alladmin";
// import Stripe from "./features/admin/third-party-config/stripe-payment/stripe";
// import SmsGateway from "./features/admin/third-party-config/sms/sms-gateway";
// import MailConfig from "./features/admin/third-party-config/mail-config/mail-config";
// import MapKey from "./features/admin/third-party-config/google-map-key/map-key";
// import FCM from "./features/admin/third-party-config/fcm/fcm";
// import Invoice from "./features/admin/invoice/invoice";
// import Profile from "./features/admin/profile/profile";
// import Language from "./features/admin/languages/languages";
import { PrivateRoute } from "./routes/PrivateRoute";
import ContactMessages from "./features/admin/contactUS/ContactMessages";
import VendorRegistrations from "./features/admin/vendor/VendorRegistrations";

function App() {
  return (
    <Router>
      <Routes>

        {/* PUBLIC WEBSITE */}
        <Route
          path="/"
          element={
            <>
              <Header />
              <HeroSection />
              <LaundryService />
              <AboutUs />
              <WhyChooseUs />
              <Advertise />
              <ContactUs />
              <Footer />
            </>
          }
        />

        {/* ADMIN LOGIN */}
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* ADMIN PANEL - NESTED ROUTES */}
        <Route element={<PrivateRoute />}>
          <Route path="/admin" element={<AdminLayout />}>
            {/* <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} /> */}

            <Route path="contact-us" element={<ContactMessages />} />
            <Route path="vendor-form" element={<VendorRegistrations />} />
          

          {/*<Route path="orders" element={<Orders />} />
          <Route path="services" element={<Services />} />
          <Route path="variants" element={<Variants />} />
          <Route path="products" element={<Products />} />
          <Route path="coupons" element={<Coupons />} />
          <Route path="notifications" element={<Notification />} />
          <Route path="price" element={<Price />} />
          <Route path="purchase" element={<Purchase />} />
          <Route path="shop-list" element={<ShopList />} />
          <Route path="revenue" element={<Revenue />} />
          <Route path="app-banners" element={<AppBanners />} />
          <Route path="customers" element={<Customers />} />
          <Route path="drivers" element={<Drivers />} />
          <Route path="stores-map" element={<Stores />} />
          <Route path="shops" element={<ShopsList />} />
          <Route path="alladmins" element={<AllAdmins />} />
          <Route path="stripe" element={<Stripe />} />
          <Route path="sms" element={<SmsGateway />} />
          <Route path="mail-config" element={<MailConfig />} />
          <Route path="map-key" element={<MapKey />} />
          <Route path="fcm" element={<FCM />} />
          <Route path="invoice" element={<Invoice />} />
          <Route path="profile" element={<Profile />} />
          <Route path="languages" element={<Language />} />
         */}
        </Route>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
